import { forwardRef, HTMLAttributes } from 'react'
import styled from 'styled-components'
import { useTabsContext } from './Tabs.provider'
import Text from '@/components/content/Text'
import { colorSystem } from '@/styles/theme'

interface TabItemProps extends HTMLAttributes<HTMLDivElement> {
  label: string
  value: string
}

export const TabItem = forwardRef<HTMLDivElement, TabItemProps>(({ label, value, ...htmlDivProps }, ref) => {
  const { selectValue, onTabChange } = useTabsContext()

  const isSelected = selectValue === value

  const handleClick = (value: string) => {
    onTabChange(value)
  }

  return (
    <TabItemWrap role="tab" aria-selected={isSelected} onClick={() => handleClick(value)} ref={ref} {...htmlDivProps}>
      <Text
        kind="Headline_20_bold"
        style={{
          transition: 'all 0.2s',
        }}
        color={isSelected ? colorSystem.text.common.primary : colorSystem.text.common.tertiary}
      >
        {label}
      </Text>
    </TabItemWrap>
  )
})

const TabItemWrap = styled.div`
  padding-bottom: 4px;
  cursor: pointer;

  &:not([aria-selected='true']):hover {
    opacity: 0.8;
  }
`
